import { useEffect, useMemo, useState } from "react";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";
import WarningsBox from "./WarningBox";
import PrivacyBox from "./PrivacyBox";
import ArrowSection from "./ArrowSection";
import Verified from "./Buttons/Verified";
import Unverified from "./Buttons/Unverified";

export default function Warnings() {
  const { t } = useTranslation("global");

  const [stepsComplete, setStepsComplete] = useState(0);
  const [verifyread, setverifyread] = useState(false);
  const [read, setRead] = useState(false);

  // Number of warnings (dynamic from i18n)
  const totalSteps = useMemo(() => {
    const arr = t("warningsSection.content", { returnObjects: true }) || [];
    return Array.isArray(arr) ? arr.length : 0;
  }, [t]);

  const handleClickScroll = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleVerifyread = () => {
    const check = document.getElementById("verifyread");
    if (check?.checked) {
      setverifyread(true);
      localStorage.setItem("verified", "true");
      setTimeout(() => handleClickScroll("start"), 100);
    } else {
      setverifyread(false);
      localStorage.removeItem("verified");
    }
  };

  const handleDownloadPdf = () => {
    const filename = "Privacy_Verklaring.pdf";
    const file = `${process.env.PUBLIC_URL}/downloads/Privacy_Verklaring.pdf`;
    fetch(file)
      .then((res) => {
        if (res.status === 200 || res.status === 0) return res.blob();
        throw new Error(res.statusText);
      })
      .then((blob) => saveAs(blob, filename))
      .catch((e) => console.error(e));
  };

  // ✅ Dynamic: user has "read" once they’ve completed ALL warnings
  useEffect(() => {
    setRead(totalSteps > 0 && stepsComplete >= totalSteps);
  }, [stepsComplete, totalSteps]);

  // If already verified, jump to done
  useEffect(() => {
    if (localStorage.getItem("verified") === "true") {
      setverifyread(true);
      setRead(true);
      setStepsComplete(totalSteps);
    }
  }, [totalSteps]);

  return (
    <div id="warn" className="mt-10 pt-10 pb-20 relative px-5 lg:px-0">
      <WarningsBox
        stepsComplete={stepsComplete}
        setStepsComplete={setStepsComplete}
        read={read}
        totalSteps={totalSteps}
      />

      <PrivacyBox
        handleVerifyread={handleVerifyread}
        handleDownloadPdf={handleDownloadPdf}
        read={read}
      />

      <ArrowSection />

      <Verified verifyread={verifyread} />
      <Unverified verifyread={verifyread} />
    </div>
  );
}
